module.exports = __webpack_public_path__ + "img/mouse-square.79f1c703.svg";